import { render, staticRenderFns } from "./IubendaCookiePopup.vue?vue&type=template&id=1d9c408e&"
import script from "./IubendaCookiePopup.vue?vue&type=script&lang=js&"
export * from "./IubendaCookiePopup.vue?vue&type=script&lang=js&"
import style0 from "./IubendaCookiePopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports